export default __webpack_public_path__ + "static/media/germany.cc670a05.png";